import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  Validators,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { AuthService } from "../../auth.service";
import { Usuario } from "src/app/shared/model/security/usuario.model";
import swal from "sweetalert2";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";

@Component({
  selector: "app-tokens",
  standalone: true,
  templateUrl: "./tokens.component.html",
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
})
export class TokensComponent implements OnInit {
  formGroupUsuario: FormGroup;
  usuarioObj: Usuario = new Usuario();
  get formUsuar() {
    return this.formGroupUsuario.controls;
  }
  constructor(
    private formBuilder: FormBuilder,
    private authS: AuthService,
      private router: Router,
      private cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.formGroupUsuario = this.formBuilder.group({
      ctrlToken: ["", [Validators.required, Validators.minLength(1)]],
      ctrlTokenAzure: ["", [Validators.required, Validators.minLength(1)]],
    });
    this.cargarTokensActuales();
  }

  cargarTokensActuales() {
    this.authS.getSesion().subscribe((res) => {
      if (!res?.usuario) {
        return;
      }

      this.usuarioObj = res.usuario;
      this.formGroupUsuario.patchValue(
        {
          ctrlToken: this.usuarioObj.token_personal ?? "",
          ctrlTokenAzure: this.usuarioObj.token_azure ?? "",
        },
        { emitEvent: false }
      );
      this.formGroupUsuario.markAsPristine();
      this.formGroupUsuario.markAsUntouched();
      this.cdr.detectChanges();
    });
  }

  actualizaToken() {
    this.authS
      .actualizaGitTokenUsuario(this.usuarioObj)
      .subscribe((response) => {
        this.formGroupUsuario.reset();
        this.usuarioObj = new Usuario();
        swal
          .fire({
            title: response.pCodRetorno === "00000" ? "Éxito" : "Error",
            text: response.pMensaje,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            confirmButtonText: "Aceptar",
            icon: response.pCodRetorno === "00000" ? "success" : "warning",
          })
          .then((responseMsg) => {
            if (response.pCodRetorno === "00000")
              this.router.navigate(["admin/ajustes"]);
          });
      });
  }

  cancelar() {
    this.router.navigate(["admin/ajustes"]);
  }
  getTokensUsuario() {
    return {
      git: this.formGroupUsuario?.get("ctrlToken")?.value ?? null,
      azure: this.formGroupUsuario?.get("ctrlTokenAzure")?.value ?? null,
    };
  }
}
